import React from "react";
import { Box, Typography } from "@material-ui/core";

export const groupKnowledgeSources = (items = []) => {
  const groups = new Map();
  items.forEach(item => {
    const key = item.sourceVersionId || `${item.knowledgeBaseName || ""}:${item.sourceName}:${item.sourceVersion}`;
    if (!groups.has(key)) groups.set(key, { ...item, items: [] });
    groups.get(key).items.push(item);
  });
  return Array.from(groups.values());
};

const safeLink = value => {
  try {
    const url = new URL(value);
    return url.protocol === "https:" && !url.username && !url.password &&
      !url.port && url.hostname.includes(".") &&
      !/(?:localhost|\.local|\.internal)$/.test(url.hostname) ? url.href : null;
  } catch { return null; }
};

export default function KnowledgeSourceGroups({ items = [], citedIds = [] }) {
  if (!items.length) return <Typography variant="body2" color="textSecondary">Nenhuma referência disponível para esta resposta.</Typography>;
  return groupKnowledgeSources(items).map((group, index) => <Box key={group.sourceVersionId || index} mb={2} style={{ overflowWrap: "anywhere" }}>
    <Typography variant="subtitle2">{group.sourceName} · v{group.sourceVersion}</Typography>
    {group.knowledgeBaseName && <Typography variant="caption" color="textSecondary">{group.knowledgeBaseName}</Typography>}
    {group.items.map((item, itemIndex) => <Box key={`${item.evidenceId}-${itemIndex}`} mt={0.75}>
      <Typography variant="caption" color="textSecondary" component="p">{[
        item.evidenceId,
        citedIds.includes(item.evidenceId) ? "Usado na resposta" : null,
        item.page ? `página ${item.page}` : null,
        item.heading,
        item.chunkId ? `Trecho ${item.chunkId}` : null,
      ].filter(Boolean).join(" · ")}</Typography>
      {item.snippet && <Typography variant="body2">{item.snippet}</Typography>}
    </Box>)}
    {safeLink(group.sourceUrl) && <Typography variant="caption"><a href={safeLink(group.sourceUrl)} target="_blank" rel="noopener noreferrer">Abrir página original</a></Typography>}
  </Box>);
}
